function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import styled from 'styled-components';
import { themeLight, spacing, breakpoints } from '@naf/theme';
import { Button } from '@naf/button';
import { Text, TextVariant } from '@naf/text';
import { nafColor } from '@nafcore/theme';
import { Cancel } from '@styled-icons/material-outlined/Cancel';
export const useCookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [cookieConsent, setCookieConsent] = useState();
  const closeCookieBanner = () => {
    setVisible(false);
  };
  const showCookieBanner = cookieBot => {
    setVisible(true);
    setCookieConsent(cookieBot);
  };
  const navigateToDeclaration = redirect => {
    if (redirect) {
      redirect();
      closeCookieBanner();
    }
  };
  const CookieBanner = ({
    children,
    submitButton,
    selectionButton,
    customizeButton,
    className,
    ...rest
  }) => /*#__PURE__*/React.createElement(Banner, _extends({
    $visible: visible,
    className: className
  }, rest), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(CloseButtonWrapper, null, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: closeCookieBanner,
    "aria-label": "Lukk informasjonskapsler"
  }, /*#__PURE__*/React.createElement(Cancel, {
    size: "24px"
  }))), /*#__PURE__*/React.createElement(Text, {
    variant: TextVariant.ArticleText
  }, children), cookieConsent && cookieConsent.dialog && /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    variant: "spruce",
    size: "small",
    onClick: () => {
      cookieConsent.dialog.submitConsent();
      closeCookieBanner();
      submitButton && submitButton.onClick();
    }
  }, submitButton && submitButton.text), /*#__PURE__*/React.createElement(Button, {
    variant: "spruce",
    size: "small",
    onClick: () => {
      cookieConsent.submitCustomConsent(selectionButton && selectionButton.preferences, selectionButton && selectionButton.statistics, selectionButton && selectionButton.marketing);
      closeCookieBanner();
      selectionButton && selectionButton.onClick();
    }
  }, selectionButton && selectionButton.text), /*#__PURE__*/React.createElement(Button, {
    variant: "spruce",
    size: "small",
    onClick: () => {
      navigateToDeclaration(customizeButton && customizeButton.redirect);
      customizeButton && customizeButton.onClick();
    }
  }, customizeButton && customizeButton.text))));
  return {
    showCookieBanner,
    closeCookieBanner,
    CookieBanner
  };
};
const Banner = styled.div.withConfig({
  displayName: "cookie-banner__Banner",
  componentId: "sc-1m1j44n-0"
})(["display:", ";background-color:", ";color:", ";align-items:center;justify-content:center;position:fixed;bottom:0;left:0;right:0;margin:0;box-shadow:0 2px ", " 'rgba(0, 0, 0, 0.24)';z-index:99999;animation:y 0.25s;@keyframes y{from{transform:translateY(100%);}to{transform:translateY(0%);}}"], ({
  $visible
}) => $visible ? 'flex' : 'none', ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.infoLight : themeLight.componentColors.alert.infoLight, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, spacing.space12);
const Content = styled.div.withConfig({
  displayName: "cookie-banner__Content",
  componentId: "sc-1m1j44n-1"
})(["display:flex;flex-direction:column;width:732px;padding-top:", ";padding-bottom:", ";p{margin:0;}@media (max-width:", "){max-width:75%;}@media (max-width:", "){padding-top:", ";padding-bottom:", ";}@media (max-width:", "){padding-top:", ";padding-bottom:", ";}"], spacing.space56, spacing.space80, breakpoints.l, breakpoints.m, spacing.space24, spacing.space64, breakpoints.s, spacing.space24, spacing.space32);
const ButtonWrapper = styled.div.withConfig({
  displayName: "cookie-banner__ButtonWrapper",
  componentId: "sc-1m1j44n-2"
})(["display:flex;margin-top:", ";> button:not(:first-of-type){margin-left:", ";}@media (max-width:", "){flex-direction:column;> button:not(:first-of-type){margin-left:0;margin-top:", ";width:100%;}> button:first-of-type{width:100%;}}"], spacing.space32, spacing.space24, breakpoints.s, spacing.space20);
const CloseButtonWrapper = styled.div.withConfig({
  displayName: "cookie-banner__CloseButtonWrapper",
  componentId: "sc-1m1j44n-3"
})(["position:relative;display:flex;justify-content:flex-end;@media (max-width:", "){justify-content:flex-end;}"], breakpoints.s);
const CloseButton = styled.button.withConfig({
  displayName: "cookie-banner__CloseButton",
  componentId: "sc-1m1j44n-4"
})(["width:", ";height:", ";border:none;background-color:transparent;color:", ";cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;margin-bottom:", ";position:absolute;right:-80px;top:-30px;@media (max-width:", "){position:static;right:auto;margin-bottom:", ";}"], spacing.space24, spacing.space24, nafColor.signature.black, spacing.space12, breakpoints.xl, spacing.space12);
//# sourceMappingURL=cookie-banner.js.map